/**
 * Sentinel for the "All" option of a `<Select>` filter. Radix `Select` forbids an empty-string item value,
 * so "no filter" is represented by this value and mapped back to `''` / `undefined` before calling the API.
 */
export const ALL_FILTER_VALUE = '__all__' as const

export type AllFilterValue = typeof ALL_FILTER_VALUE
